import { createContext, useContext, useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "comparar_ids";
const MAX = 3;

const ComparisonContext = createContext(null);

export function ComparisonProvider({ children }) {
  const [comparisonIds, setComparisonIds] = useState(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
      }
    } catch (_) {}
    return [];
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(comparisonIds));
    } catch (_) {}
  }, [comparisonIds]);

  const addToComparison = useCallback((id) => {
    setComparisonIds((prev) => {
      if (prev.includes(id)) return prev;
      if (prev.length >= MAX) return prev;
      return [...prev, id];
    });
  }, []);

  const removeFromComparison = useCallback((id) => {
    setComparisonIds((prev) => prev.filter((x) => x !== id));
  }, []);

  const clearComparison = useCallback(() => {
    setComparisonIds([]);
  }, []);

  const isInComparison = useCallback(
    (id) => comparisonIds.includes(id),
    [comparisonIds]
  );

  return (
    <ComparisonContext.Provider
      value={{
        comparisonIds,
        addToComparison,
        removeFromComparison,
        clearComparison,
        isInComparison,
        maxComparison: MAX,
      }}
    >
      {children}
    </ComparisonContext.Provider>
  );
}

export function useComparison() {
  const ctx = useContext(ComparisonContext);
  if (!ctx) throw new Error("useComparison must be used within ComparisonProvider");
  return ctx;
}
